import type { ColoredMaterial } from "@color-finder/color-finder-api/models";
import type { NamedColor } from "../components/filter/color-filter/ColorFilter";
import { formatMeasurementCondition } from "../service/measurement-condition";

export function usePreviewSpecification(
  material: ColoredMaterial,
): NamedColor | undefined {
  const preview = material.color.specifications?.preview;
  const deltaE = material.color.specifications?.deltaE;

  if (!preview || !deltaE) {
    return undefined;
  }

  return {
    value: preview.cieLab,
    name: `${material.material.grade} / ${material.color.finalColorCode ?? material.color.preliminaryColorCode}`,
    measurementCondition: formatMeasurementCondition(preview),
    warning: preview.warning,
    deltaE,
  };
}
